export default __webpack_public_path__ + "static/media/spinner.e97dcc95.gif";